import { VerticalAlignTopOutlined } from '@ant-design/icons'
import { useFormatter } from '@api/useFormatter'
import { Horizontal, Texto, Vertical, BBDTag } from '@gravitate-js/excalibrr'
import { Tooltip } from 'antd'
import React from 'react'

export const EmptyPocket = ({ index, volumes, maxVolumes }) => {
  const { formatVolume } = useFormatter()
  return (
    <Vertical gap={4} border='all' style={{ height: 'auto' }} className='pocket-container p-3 flex-1'>
      <Horizontal style={{ flex: 1 }}>
        <Horizontal flex='none'>
          <BBDTag style={{ height: 'fit-content' }}>{index + 1}</BBDTag>
        </Horizontal>
        <Horizontal flex={11}>
          <Texto appearance='hint' weight='bold'>
            EMPTY
          </Texto>
        </Horizontal>
      </Horizontal>

      <Horizontal gap={16}>
        <Tooltip title='Default Volume'>
          <Texto weight='600' category='p2'>
            {formatVolume(volumes[index], true)}
          </Texto>
        </Tooltip>
        <Tooltip title='Max Volume'>
          <Texto category='p1' appearance='medium'>
            <VerticalAlignTopOutlined /> {formatVolume(maxVolumes[index], true)}
          </Texto>
        </Tooltip>
      </Horizontal>

      <Texto appearance='hint'>Select a product to fill the container.</Texto>
    </Vertical>
  )
}
